// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"324":"scene","443":"about"}[chunkId] + "." + {"324":"3335397d","443":"139dde10"}[chunkId] + ".css";
};